import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Table,
  Label,
  FormGroup,
  Button,
  Badge,
  Alert
} from 'reactstrap';
import { connect } from 'react-redux';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import PageDataLoader from '../Utility/PageDataLoader';
import Paginator from '../Utility/Paginator';
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { validatePermissionKey } from '../../helpers/permission';
import {
  VIEW_TRANSACTION,
  DELETE_TRANSACTION,
  UPDATE_TRANSACTION
} from '../Utility/PermissionKeys';
import {
  fetchAllTransactionsList,
  alterForTransaction,
  deleteTransaction,
  refetchTransactionStatus
} from '../../api/transaction';
import InvoiceModal from '../../components/Invoice';
import FilterModal from './FilterModal';
import EditTransactionModal from '../Child/EdittransactionModal';
import { getEffectivePenalty } from '../../helpers/transaction';

const Transactions = ({ authUser }) => {
  const [breadcrumbItems] = useState([
    { title: 'Transactions', link: '#' },
    { title: 'View List', link: '#' }
  ]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageLimit: 100,
    totalEntries: 0,
    totalPages: 0
  });
  const [successAlert, setSuccessAlert] = useState({
    show: false,
    message: ''
  });
  const [errorAlert, setErrorAlert] = useState({
    show: false,
    message: ''
  });
  const [invoiceModal, setInvoiceModal] = useState({
    open: false,
    data: null
  });
  const [loading, setLoading] = useState(true);
  const [transactionList, setTransactionList] = useState([]);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filters, setFilters] = useState({
    isPaid: '',
    isOverdue: false,
    childrenId: '',
    batchId: '',
    offeringId: '',
    start_date: '',
    end_date: ''
  });
  const [filterCount, setFilterCount] = useState(0);
  const [sortingRule, setSortingRule] = useState('createdAt$desc');
  const [refresh, setRefresh] = useState(false);
  const [deleteModal, setDeleteModal] = useState(null);
  const [editModal, setEditModal] = useState({
    open: false,
    data: null
  });
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: '',
    type: 'success'
  });
  const [refetchLoading, setRefetchLoading] = useState(false);


  const handleRefresh = () => {
    setRefresh((prev) => !prev);
  };

  const tableColumns = [
    { label: 'SL. NO', key: 'srNo' },
    {
      label: 'Child',
      key: 'childName',
      render: (row) => (
        <Link to={`/children/view/${row.childId}`}>{row.childName}</Link>
      )
    },
    {
      label: 'Batch',
      key: 'batchName',
      render: (row) => (
        <Link to={`/batches/view/${row.batchId}`}>{row.batchName}</Link>
      )
    },
    { label: 'Offering', key: 'offeringName' },
    { label: 'Quarter', key: 'quarter' },
    {
      label: 'Status',
      key: 'status',
      render: (row) => (
        <Badge
          style={{ fontWeight: 'bold', fontSize: '12px' }}
          color={row.status !== false ? 'success' : row?.razorpayOrderId ? 'warning' : 'secondary'}
        >
          {row.status !== false ? 'Paid' : row?.razorpayOrderId ? 'Pending' : 'Unpaid'}
        </Badge>
      )
    },
    { label: 'Initial Amount (Rs)', key: 'totalAmountToPay' },
    {
      label: 'Total Batch Fee (Rs)',
      key: 'totalFee',
      render: (row) => row.totalFee != null ? `₹${row.totalFee}` : '—'
    },
    { label: 'Promo Discount (Rs)', key: 'promoDiscount' },
    {
      label: 'Penalty Mode',
      key: 'penaltyMode',
      render: (row) => {
        if (!row.penaltyPercentage && row.penaltyPercentage !== 0) return '—';
        return row.penaltyMode === 'daily_flat'
          ? <span>Flat/day</span>
          : <span>Percentage</span>;
      }
    },
    {
      label: 'Penalty Rate',
      key: 'penaltyPercentage',
      render: (row) => {
        if (row.penaltyPercentage == null) return '—';
        return row.penaltyMode === 'daily_flat'
          ? `₹${row.penaltyPercentage}/day`
          : `${row.penaltyPercentage}%`;
      }
    },
    {
      label: 'Due Date',
      key: 'dueDate',
      render: (row) => row.dueDate
        ? new Date(row.dueDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
        : '—'
    },
    {
      label: 'Late Fee (Rs)',
      key: 'penaltyAmount',
      render: (row) => {
        const penalty = row?.isPenaltyIgnored ? 0 : Number(row?.penaltyAmount || 0);
        if (penalty > 0) return <span style={{ color: '#c0392b' }}>₹{penalty}</span>;
        return <span>
          ₹0
          {row.penaltyDeadline && row.status === false && (
            <small className="d-block text-muted" style={{ fontSize: '0.72rem' }}>
              From {new Date(row.penaltyDeadline).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}
              {row.penaltyDay != null && (
                <span className="d-block">({row.penaltyDay} day grace)</span>
              )}
            </small>
          )}
        </span>;
      }
    },
    { label: 'Adjusted Amount (Rs)', key: 'adjustedAmount' }
  ];

  useEffect(() => {
    if (authUser) {
      handleFetchData(
        pagination.currentPage,
        pagination.pageLimit,
        filters,
        sortingRule
      );
    }
  }, [authUser, filters, sortingRule, refresh]);

  const updateTransactionAction = (list, transactionId, updates) => {
    return list.map((item) =>
      item._id === transactionId
        ? {
          ...item,
          actions: item.actions.map((action, idx) =>
            idx === 1 ? { ...action, ...updates } : action
          )
        }
        : item
    );
  };

  const handleAlterForTransaction = async (transactionId) => {
    setTransactionList((prev) =>
      updateTransactionAction(prev, transactionId, {
        disabled: true,
        label: 'Alerting...'
      })
    );

    const { error } = await alterForTransaction(transactionId);

    if (error) {
      setErrorAlert({
        show: true,
        message: error || 'Failed to alert parent'
      });
    } else {
      setSuccessAlert({
        show: true,
        message: 'Alert sent successfully'
      });
    }

    setTransactionList((prev) =>
      updateTransactionAction(prev, transactionId, {
        disabled: false,
        label: 'Alert'
      })
    );
  };

  const handleDeleteTxn = async () => {
    setDeleteModal(null);
    try {
      const res = await deleteTransaction(deleteModal);
      if (res?.error) {
        setAlertMessage({
          open: true,
          message: res.error,
          type: 'error'
        });
        return;
      } else {
        setAlertMessage({
          open: true,
          message: 'Transaction deleted successfully',
          type: 'success'
        });
      }
    } catch (error) {
      console.error('Error deleting transaction:', error);
    }
  };

  const handleFetchData = async (page, limit, filters = {}, sorting_option) => {
    setLoading(true);
    const params = {
      ...filters,
      page,
      limit,
      sorting_option
    };
    const { response, error } = await fetchAllTransactionsList(params);
    if (error) {
      setErrorAlert({
        show: true,
        message: error || 'Failed to fetch transactions'
      });
      setLoading(false);
      console.error('Failed to fetch transactions: ', error);
      return;
    }
    const data = response?.data?.map((t, idx) => {
      let actions = [
        {
          label: 'Invoice',
          onClick: () => {
            setInvoiceModal({ open: true, data: t });
          },
          icon: 'receipt',
          color: 'primary',
          disabled: t.isPaid === false
        },
        {
          label: 'Alert',
          onClick: () => {
            handleAlterForTransaction(t._id);
          },
          icon: 'bell',
          color: 'danger',
          disabled: t.isPaid !== false
        },
        {
          label: 'Edit',
          onClick: () => {
            setEditModal({ open: true, data: t });
          },
          icon: 'edit',
          color: 'warning',
          disabled:
            !validatePermissionKey(authUser, UPDATE_TRANSACTION) || (t.isPaid && !t?.isCashPayment)
        },
        {
          label: 'Delete',
          onClick: () => setDeleteModal(t?._id),
          icon: 'trash',
          color: 'danger',
          disabled:
            t.isPaid !== false ||
            !validatePermissionKey(authUser, DELETE_TRANSACTION)
        },
        {
          label: 'Refresh Status',
          onClick: () => handleRefreshStatus(t?._id),
          icon: 'sync',
          color: 'info',
          disabled:
            t.isPaid || refetchLoading
        }
      ];
      const quarterData =
        t?.quarter !== undefined && t?.quarter !== null
          ? t?.batchId?.quarters && t?.batchId?.quarters.length
            ? t?.batchId?.quarters[t?.quarter - 1]
            : t?.batchId[`quarter${t?.quarter}`]
          : null;
      return {
        _id: t?._id,
        srNo: idx + 1,
        status: t?.isPaid,
        razorpayOrderId: t?.razorpayOrderId,
        childName: t?.childrenId?.name,
        childId: t?.childrenId?._id,
        email: t?.childrenId?.email_address,
        batchName: t?.batchId?.name,
        batchId: t?.batchId?._id,
        totalFee: t?.batchId?.totalFee,
        offeringName: t?.batchId?.offering?.name || '—',
        quarter: quarterData?.month
          ? moment(quarterData?.month).format('MMM YYYY')
          : 'N/A',
        totalAmountToPay: Math.ceil(t?.totalAmountToPay),
        promoDiscount: t?.discountAmount ? Math.ceil(t.discountAmount) : '—',
        penaltyMode: t?.penaltyMode || t?.batchId?.penaltyMode || 'percentage',
        penaltyPercentage: t?.penaltyPercentage ?? null,
        dueDate: t?.dueDate || null,
        penaltyDeadline: t?.penaltyDeadline || null,
        penaltyAmount: t?.penaltyAmount || 0,
        isPenaltyIgnored: t?.isPenaltyIgnored || false,
        penaltyDay: t?.penaltyDay ?? null,
        adjustedAmount:
          Math.ceil((t?.totalAmountToPay || 0) +
          getEffectivePenalty(t) -
          (t?.discountAmount || 0)),
        createdAt: t.createdAt
          ? moment(t.createdAt).format('DD MMM YYYY')
          : 'N/A',
        updatedAt: t.updatedAt
          ? moment(t.updatedAt).format('DD MMM YYYY')
          : 'N/A',
        actions
      };
    });
    setTransactionList(data);
    setPagination({
      currentPage: response?.metadata?.page,
      pageLimit: response?.metadata?.limit,
      totalPages: response?.metadata?.total_pages,
      totalEntries: response?.metadata?.total_results
    });
    setLoading(false);
  };

  const handlePageChange = (page) => {
    handleFetchData(page, pagination.pageLimit, filters, sortingRule);
  };
  const handleLimitChange = (limit) => {
    handleFetchData(1, limit, filters, sortingRule);
  };

  const handleEditSuccess = (message) => {
    setSuccessAlert({
      show: true,
      message: message || 'Transaction updated successfully'
    });
    handleRefresh(); // Refresh the transaction list
  };

  const handleRefreshStatus = async (id) => {
    setRefetchLoading(true);
    const response = await refetchTransactionStatus(id);
    if (response?.error) {
      setAlertMessage({
        open: true,
        message: response?.error,
        type: 'error'
      });
      setRefetchLoading(false);
      return;
    } else {
      setAlertMessage({
        open: true,
        message: 'Transaction status refreshed successfully',
        type: 'success'
      });
      handleRefresh();
    }
    setRefetchLoading(false);
  };

  return (
    <div className="page-content">
      {deleteModal && (
        <SweetAlert
          warning
          showCancel
          confirmBtnText="Confirm"
          confirmBtnBsStyle="danger"
          title="Are you sure?"
          onConfirm={handleDeleteTxn}
          onCancel={() => setDeleteModal(null)}
          focusCancelBtn
        >
          This will permanently delete the transaction and this action cannot be
          undone.
        </SweetAlert>
      )}

      {alertMessage.open && (
        <SweetAlert
          danger={alertMessage.type === 'error' ? true : false}
          success={alertMessage.type === 'success' ? true : false}
          title= {alertMessage.type === 'success' ? "Updated" : "Error"}
          onConfirm={() => {
            setAlertMessage({
              open: false,
              message: '',
              type: 'success'
            });
            handleRefresh();
          }}
        >
          {alertMessage.message}
        </SweetAlert>
      )}
      <Container fluid>
        {successAlert.show && (
          <SweetAlert
            success
            title="Success"
            onConfirm={() => setSuccessAlert({ show: false, message: '' })}
          >
            {successAlert.message}
          </SweetAlert>
        )}

        {errorAlert.show && (
          <SweetAlert
            error
            title="Error"
            onConfirm={() => setErrorAlert({ show: false, message: '' })}
          >
            {errorAlert.message}
          </SweetAlert>
        )}

        <Breadcrumbs title="Transactions" breadcrumbItems={breadcrumbItems} />
        <Row>
          <Col>
            <Card>
              <CardBody>
                {/* OPTIONS */}
                <Row className="mt-2">
                  <Col md="2">
                    <FormGroup>
                      <Label className="col-form-label">Show Entries</Label>
                      <select
                        className="form-control"
                        onChange={(e) => handleLimitChange(e.target.value)}
                        value={pagination.pageLimit}
                        disabled={loading}
                      >
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                      </select>
                    </FormGroup>
                  </Col>
                  <Col md="3">
                    <FormGroup>
                      <Label className="col-form-label">Sort Queries</Label>
                      <select
                        className="form-control"
                        onChange={(e) => {
                          setSortingRule(e.target.value);
                        }}
                        value={sortingRule}
                        disabled={loading}
                      >
                        <option value="createdAt$desc">
                          Create Time (Newest First)
                        </option>
                        <option value="createdAt$asc">
                          Create Time (Oldest First)
                        </option>
                      </select>
                    </FormGroup>
                  </Col>
                  <Col className="d-flex justify-content-end align-items-center">
                    <Button
                      size="sm"
                      color="primary"
                      className=" waves-effect waves-light mr-3"
                      onClick={() => setFilterModalOpen(true)}
                    >
                      <i className="ri-filter-fill align-middle mr-2"></i>
                      <span>Filter Queries</span>
                      {filterCount > 0 && (
                        <Badge color="light" pill className="ml-2">
                          {filterCount}
                        </Badge>
                      )}
                    </Button>
                  </Col>
                </Row>

                {/* Table */}
                {loading ? (
                  <div className="text-center">
                    <PageDataLoader height={40} width={40} />
                  </div>
                ) : (
                  <div className="table-rep-plugin">
                    <div
                      className="table-responsive mb-0"
                      data-pattern="priority-columns"
                    >
                      <Table id="tech-companies-1" striped bordered responsive>
                        <thead>
                          <tr>
                            {tableColumns.map((col, index) => (
                              <th key={index} style={{ whiteSpace: 'nowrap' }}>
                                {col.label}
                              </th>
                            ))}
                            <th>Actions</th>
                          </tr>
                        </thead>
                        {transactionList.length === 0 ? (
                          <tbody>
                            <tr>
                              <td
                                colSpan={tableColumns?.length + 1}
                                className="text-center"
                              >
                                No Data Available
                              </td>
                            </tr>
                          </tbody>
                        ) : (
                          <tbody>
                            {transactionList?.map((row, index) => (
                              <tr key={index}>
                                {tableColumns?.map((col, idx) => (
                                  <td
                                    key={idx}
                                    style={{ whiteSpace: 'nowrap' }}
                                  >
                                    {col?.render
                                      ? col?.render(row)
                                      : row[col?.key]}
                                  </td>
                                ))}
                                <td>
                                  <div className="d-flex align-items-center">
                                    {row?.actions?.map((action, index) => (
                                      <Button
                                        key={index}
                                        size="sm"
                                        color={action.color}
                                        className=" waves-effect waves-light mr-2"
                                        onClick={action.onClick}
                                        style={{ whiteSpace: 'nowrap' }}
                                        disabled={action?.disabled ?? false}
                                        title={action.label}
                                      >
                                        <i
                                          className={`fas fa-${action.icon}`}
                                        ></i>
                                      </Button>
                                    ))}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        )}
                      </Table>
                    </div>
                  </div>
                )}

                {/* Pagination */}
                <Row className="mt-2">
                  <Col md="5">
                    <p>
                      <strong>
                        {' '}
                        Showing{' '}
                        {(pagination.currentPage - 1) * pagination.pageLimit +
                          1}{' '}
                        to{' '}
                        {Math.min(
                          pagination.currentPage * pagination.pageLimit,
                          pagination.totalEntries
                        )}{' '}
                        of {pagination.totalEntries} entries
                      </strong>
                    </p>
                  </Col>
                  {!loading && transactionList.length > 0 && (
                    <Col md="7">
                      <Paginator
                        totalPages={pagination.totalPages}
                        currentPage={pagination.currentPage}
                        changePage={(page) => handlePageChange(page)}
                      />
                    </Col>
                  )}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {invoiceModal.open && (
        <InvoiceModal
          open={invoiceModal.open}
          handleClose={() => setInvoiceModal({ open: false, data: null })}
          transactionData={invoiceModal?.data}
        />
      )}

      {filterModalOpen && (
        <FilterModal
          isOpen={filterModalOpen}
          handleClose={() => setFilterModalOpen(false)}
          filters={filters}
          setFilters={setFilters}
          setFilterCount={setFilterCount}
        />
      )}

      {editModal.open && (
        <EditTransactionModal
          modalOpenState={editModal.open}
          closeModalHandler={() => setEditModal({ open: false, data: null })}
          data={editModal.data}
          refresh={handleRefresh}
          onSuccess={handleEditSuccess}
          onError={(message) => setErrorAlert({ show: true, message })}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(Transactions);
